import React, { useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import HowAreYouFeeling from '../../../questionnaire/cosmetic/how_are_you_feeling';
import ChooseAnOption from '../../../questionnaire/choose_an_option';
import YesNoExtra from '../../../questionnaire/yes_no_extra';

function Ossio({ path, update, answeredFinalQuestion, history, conversationSurvey }) {
  const [rating, setRating] = useState('');
  const [comfortLevel, setComfortLevel] = useState('');
  const [confidenceLevel, setConfidenceLevel] = useState('');
  const [feelingNow, setFeelingNow] = useState('');
  const [connectionWithOthers, setConnectionWithOthers] = useState('');
  const [isReadyForNextStep, setIsReadyForNextStep] = useState('');
  const [recommendProgram, setRecommendProgram] = useState('');

  const steps = [
    'comfort-level',
    'confidence-level',
    'feeling-now',
    'connection-with-others',
    'recommend-program',
    'ready-for-next-step',
  ];

  let nextStep = steps[steps.findIndex((r) => window.location.pathname.includes(r)) + 1];
  let previousStep = steps[steps.findIndex((r) => window.location.pathname.includes(r)) - 1];

  if (!nextStep) {
    nextStep = steps[-1];
  }

  if (!previousStep) {
    previousStep = '';
  }

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <HowAreYouFeeling
          title={`Rate the conversation with your mentor ${conversationSurvey.patient_mentor_name}`}
          para="Your rating is confidential. It helps us make sure you're receiving the support you need and allows us to improve the experience for others like you."
          answers={{ rating: rating }}
          numberRating={true}
          onSubmit={(answers) => {
            setRating(answers.rating);
            update({ rating: answers.rating });
            history.push(`${path}/${nextStep}`);
          }}
          star={true}
          icons={[
            { text: 'Very disappointing' },
            { text: 'Disappointing' },
            { text: 'Somewhat helpful' },
            { text: 'Helpful' },
            { text: 'Very helpful' },
          ]}
          textLabels={['Very disappointing', 'Disappointing', 'Somewhat helpful', 'Helpful', 'Very helpful']}
          keyForAnswer={'rating'}
        />
      </Route>

      <Route exact path={`${path}/comfort-level`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setComfortLevel(answers.comfort_level);
            update({ data: { comfort_level: answers.comfort_level } });
            history.push(`${path}/${nextStep}`);
          }}
          onBack={() => {
            history.push(`${path}/${previousStep}`);
          }}
          answers={{ data: { comfort_level: comfortLevel } }}
          title={`My mentor made me feel more motivated about starting or continuing treatment for my condition.`}
          para={'Helps us understand if your mentor eased your treatment concerns.'}
          keyForAnswer={'comfort_level'}
          choices={['Strongly agree', 'Agree', 'Neither agree or disagree', 'Disagree', 'Strongly disagree']}
          showOther={false}
          selectOne
        />
      </Route>

      <Route exact path={`${path}/confidence-level`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setConfidenceLevel(answers.confidence_level);
            update({ data: { confidence_level: answers.confidence_level } });
            history.push(`${path}/${nextStep}`);
          }}
          onBack={() => {
            history.push(`${path}/${previousStep}`);
          }}
          answers={{ data: { confidence_level: confidenceLevel } }}
          title={`My mentor helped build trust in the OSSIOfiber® brand.`}
          para={'Let us know if your mentor helped you feel more comfortable choosing OSSIOfiber®.'}
          keyForAnswer={'confidence_level'}
          choices={['Strongly agree', 'Agree', 'Neither agree or disagree', 'Disagree', 'Strongly disagree']}
          showOther={false}
          selectOne
        />
      </Route>

      <Route exact path={`${path}/feeling-now`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setFeelingNow(answers.feeling_now);
            update({ data: { feeling_now: answers.feeling_now } });
            history.push(`${path}/${nextStep}`);
          }}
          onBack={() => {
            history.push(`${path}/${previousStep}`);
          }}
          answers={{ data: { feeling_now: feelingNow } }}
          title={`How are you feeling about getting treatment or procedure now?`}
          para={'Helps us understand if your mentor provided the support you needed.'}
          keyForAnswer={'feeling_now'}
          choices={['Very Excited', 'Excited', 'Unsure', 'Nervous', 'Very Nervous']}
          showOther={false}
          selectOne
        />
      </Route>

      <Route exact path={`${path}/connection-with-others`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setConnectionWithOthers(answers.connection_with_others);
            update({ data: { connection_with_others: answers.connection_with_others } });
            history.push(`${path}/${nextStep}`);
          }}
          onBack={() => {
            history.push(`${path}/${previousStep}`);
          }}
          answers={{ data: { connection_with_others: connectionWithOthers } }}
          title={'I feel more connected to others with my condition.'}
          para={'Helps us understand if the program made you feel less alone in your journey.'}
          keyForAnswer={'connection_with_others'}
          choices={['True', 'False']}
          showOther={false}
          selectOne
        />
      </Route>

      <Route exact path={`${path}/recommend-program`}>
        <ChooseAnOption
          onSubmit={(answers) => {
            setRecommendProgram(answers.recommend_program);
            update({ data: { recommend_program: answers.recommend_program } });
            history.push(`${path}/${nextStep}`);
          }}
          onBack={() => {
            history.push(`${path}/${previousStep}`);
          }}
          answers={{ data: { recommend_program: recommendProgram } }}
          title={'I would recommend the mentor program to someone else with my condition'}
          para={'Helps us understand if the program was valuable and supportive for you.'}
          keyForAnswer={'recommend_program'}
          choices={['Strongly agree', 'Agree', 'Neither agree or disagree', 'Disagree', 'Strongly disagree']}
          showOther={false}
          selectOne
        />
      </Route>

      <Route exact path={`${path}/ready-for-next-step`}>
        <div className={`row activity-question`}>
          <YesNoExtra
            onSubmit={(answers) => {
              setIsReadyForNextStep(answers.ready_for_next_step);
              answeredFinalQuestion({
                ready_for_next_step: answers.ready_for_next_step,
              });
            }}
            onBack={() => {
              history.push(`${path}/${previousStep}`);
            }}
            answers={{ ready_for_next_step: isReadyForNextStep }}
            title={`Are you ready to keep moving forward with your treatment or procedure?`}
            para={`Helps us understand if you feel prepared to take the next step.`}
            keyForAnswer={'ready_for_next_step'}
            ctaText='Submit'
            extraIndex={1}
          />
        </div>
      </Route>
    </Switch>
  );
}

export default Ossio;
